import { render, staticRenderFns } from "./StartPage.vue?vue&type=template&id=72c6ba63&"
import script from "./StartPage.vue?vue&type=script&lang=js&"
export * from "./StartPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports